import { Injectable } from '@angular/core';
import { SETTINGS } from '../config/common.settings';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root',
})
export class EncryptionService {
  encrypt(data: any): string {
    return CryptoJS.AES.encrypt(
      JSON.stringify(data),
      SETTINGS.KEYS.SECRET,
    ).toString();
  }

  decrypt(ciphertext: string): any {
    const bytes = CryptoJS.AES.decrypt(ciphertext, SETTINGS.KEYS.SECRET);
    return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  }
}
